import { useTranslation } from 'react-i18next';
import { WithContext, ProfilePage } from 'schema-dts';

export const ProfileJSONLD: (props: {
  name: string;
  desc: string;
  avatar: string;
  likeCount: number;
  followCount: number;
  favoriteCount: number;
  postCount: number;
  uniqueName: string;
}) => JSX.Element = (props) => {
  const { name, desc, avatar, likeCount, followCount, favoriteCount, postCount, uniqueName } = props;

  const { t } = useTranslation();

  const description = t('user_helmet_description_1')
    .replace('%1$s', name || '')
    .replace('%2$s', desc || '');

  const jsonLD: WithContext<ProfilePage> = {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name,
      alternateName: uniqueName,
      identifier: {
        '@type': 'PropertyValue',
        propertyID: 'Username',
        value: uniqueName,
      },
      interactionStatistic: [
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'LikeAction',
          },
          userInteractionCount: likeCount,
        },
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'FollowAction',
          },
          userInteractionCount: followCount,
        },
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'BookmarkAction',
          },
          userInteractionCount: favoriteCount,
        },
        {
          '@type': 'InteractionCounter',
          interactionType: {
            '@type': 'WriteAction',
          },
          userInteractionCount: postCount,
        },
      ],
      description,
      image: avatar,
    },
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }}></script>;
};
